import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseService } from '../../../../../assist/src/app/_shared/services/base.service';
import { UserPersonDto, UserPersonListDto } from "../models/user-person";
import { ApprovalResultDto, CouplingResultDto, MatchablePersonDto } from "../models/coupling";

@Injectable({ providedIn: "root" })
export class UserPersonService extends BaseService<UserPersonDto, UserPersonListDto> {
  constructor(
    protected override http: HttpClient,
    @Inject("PUBLIC_BASE_URL") protected override baseUrl: string
  ) {
    super(http, baseUrl, "userPerson");
  }

  addToUser(memberOrPersonKey: string, organizationKey: string): Observable<CouplingResultDto> {
    const params = new HttpParams()
      .set("memberOrPersonKey", memberOrPersonKey)
      .set("organizationKey", organizationKey);
    return this.http.post<CouplingResultDto>(`${this.baseUrl}userPerson/add`, {}, { params });
  }

  // Kandidaten met hetzelfde geverifieerde e-mailadres, om in de modal ter selectie te tonen. Koppelt niets.
  getMatchableByEmail(organizationKey: string): Observable<MatchablePersonDto[]> {
    const params = new HttpParams().set("organizationKey", organizationKey);
    return this.http.get<MatchablePersonDto[]>(`${this.baseUrl}userPerson/matchableByEmail`, { params });
  }

  // Koppelt de aangevinkte personen (server-side opnieuw gevalideerd). Geeft het aantal nieuw gekoppelde terug.
  coupleByEmail(organizationKey: string, personIds: number[]): Observable<number> {
    const params = new HttpParams().set("organizationKey", organizationKey);
    return this.http.post<number>(`${this.baseUrl}userPerson/coupleByEmail`, personIds, { params });
  }

  approveCoupling(token: string): Observable<ApprovalResultDto> {
    const params = new HttpParams().set("token", token);
    return this.http.post<ApprovalResultDto>(`${this.baseUrl}userPerson/approveCoupling`, {}, { params });
  }

  rejectCoupling(token: string): Observable<ApprovalResultDto> {
    const params = new HttpParams().set("token", token);
    return this.http.post<ApprovalResultDto>(`${this.baseUrl}userPerson/rejectCoupling`, {}, { params });
  }
}
